import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/agreement-type/`;

const getAgreementTypes = async () => {
    return await axios.get(API_URL);
};

const editAgreementType = async (agreementTypeId, updatedData) => {
    return await axios.put(API_URL + agreementTypeId, updatedData);
};

const publishAgreementVersion = async (agreementTypeId, data) => {
    return await axios.post(API_URL + agreementTypeId + '/publish', data);
};

export default {
    getAgreementTypes,
    editAgreementType,
    publishAgreementVersion
};
